<template>
  <div>
    <!--begin::Dashboard-->
    <!--begin::Row-->
    <div class="row">
      <div class="col-lg-12">
        <AdvancedTableWidget3
          v-bind:whitelists="whitelists"
        ></AdvancedTableWidget3>
      </div>
    </div>
    <!--end::Row-->
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AdvancedTableWidget3 from "@/view/content/widgets/advance-table/Widget3.vue";
import { mapState } from "vuex";
import { FETCH_WHITELIST } from "@/core/services/store/whitelist.module";

export default {
  name: "dashboard",
  components: {
    AdvancedTableWidget3,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.$store.dispatch(FETCH_WHITELIST);
  },
  methods: {
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
  },
  computed: {
    ...mapState({
      whitelists: (state) => state.whitelist.whitelist,
    }),
  },
};
</script>
